// src/components/DashboardSidebar.jsx

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const navItems = [
    { name: 'Dashboard Home', icon: '[Home]', path: '/app/dashboard' },
    { name: 'My Profile', icon: '[User]', path: '/app/profile' },
    { name: 'Community Feed', icon: '[Chat]', path: '/app/feed' },
    { name: 'Local Events', icon: '[Calendar]', path: '/app/events' },
    { name: 'Settings', icon: '[Cog]', path: '/app/settings' },
];

const DashboardSidebar = () => {
    return (
        <nav className="dashboard-sidebar">
            <div className="sidebar-header">
                <h3 className="sidebar-brand">NYC Connect</h3>
            </div>
            <ul className="sidebar-nav-list">
                {navItems.map((item) => (
                    <li key={item.name} className="sidebar-nav-item">
                        <RouterLink to={item.path} className="sidebar-nav-link">
                            <span className="sidebar-icon">{item.icon}</span>
                            {item.name}
                        </RouterLink>
                    </li>
                ))}
            </ul>
            <div className="sidebar-footer">
                <button className="sidebar-logout-btn">
                    Logout
                </button>
            </div>
        </nav>
    );
};

export default DashboardSidebar;